import { envsEnum } from '@helpers/env-enum';
import Head from 'next/head';
import { theme } from 'tailwind.config';

import { brandName, brandTwitterHandle } from '@helpers/constants';

const NextHeadTag = ({
    title,
    canonicalUrl,
    metaTitle,
    metaDesc,
    metaKeywords,
    metaIndex = 'index, follow',
    schemaMarkup = null,
    schemaProps = {},
    themeColor = null,
    includeSocialMediaTags = false,
    image,
    ogType,

}) => {
    // Determine the value of metaRobotsContent based on the environment
    const metaRobotsContent = process.env.NEXT_PUBLIC_CURRENT_ENV === envsEnum.PRODUCTION ? metaIndex : 'noindex';
    const effectiveThemeColor = themeColor || theme?.colors?.basicWhite;

    return (
        <Head>
            <meta charSet="utf-8" />
            {title ? <title>{title}</title> : null}
            {canonicalUrl ? <link rel="canonical" href={canonicalUrl} /> : null}
            {/* MetaTitle is no more needed for SEO. do not use it. Instead use title */}
            {metaTitle ? <meta name="title" content={metaTitle} /> : null}
            {metaDesc ? <meta name="description" content={metaDesc} /> : null}
            {metaKeywords ? (
                <meta name="keywords" content={metaKeywords} />
            ) : null}
            {metaRobotsContent ? <meta name="robots" content={metaRobotsContent} /> : null}
            <meta property="og:type" content={ogType || "website"} />
            <meta property="og:site_name" content={brandName} />
            {canonicalUrl ? <meta property="og:url" content={canonicalUrl} /> : null}
            <meta name="msapplication-TileColor" content={effectiveThemeColor} />
            <meta name="theme-color" content={effectiveThemeColor} />
            {includeSocialMediaTags ?
                <>
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:site" content={brandTwitterHandle} />
                    <meta name="twitter:creator" content={brandTwitterHandle} />
                </> : null}
            {includeSocialMediaTags && title ?
                <>
                    <meta property="og:title" content={title} />
                    <meta name="twitter:title" content={title} />
                </>
                : null}
            {includeSocialMediaTags && metaDesc ?
                <>
                    <meta property="og:description" content={metaDesc} />
                    <meta name="twitter:description" content={metaDesc} />
                </>
                : null}
            {includeSocialMediaTags && image ?
                <>
                    <meta property="og:image" content={image} />
                    <meta name="twitter:image" content={image} />
                </>
                : null}
            {schemaMarkup && schemaMarkup(schemaProps)}
        </Head>
    );
};

export default NextHeadTag;